import { FC, memo, ReactElement, useCallback } from 'react';

import { useNavigate } from 'react-router';
import { useAppPagination } from '../../../../../common/hooks';
import { AppRoutes } from '../../../../../common/interfaces';
import { FallbackedLayout } from '../../../../../common/layouts';
import { useGetAllSitemapQuery } from '../../../queries';
import { SitemapDomainsListView } from './SitemapDomainsListView';

interface Props {
  siteId: string;
}

export const SitemapDomainsListContainer: FC<Props> = memo(({ siteId }) => {
  const navigate = useNavigate();
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: siteDomainsData,
    error: siteDomainsError,
    isError: isSiteDomainsError,
    isLoading: isSiteDomainsLoading,
    isFetching: isSiteDomainsFetching
  } = useGetAllSitemapQuery(siteId, { page: currentPage })({
    enabled: !!siteId
  });

  const handleBack = useCallback((): void => {
    navigate(AppRoutes.SitesById.replace(':siteId', siteId));
  }, [siteId]);

  return (
    <FallbackedLayout
      data={ siteDomainsData }
      error={ siteDomainsError }
      isError={ isSiteDomainsError }
      isLoading={ isSiteDomainsLoading }
    >
      { (domainsList): ReactElement => (
        <SitemapDomainsListView
          siteId={ siteId }
          currentPage={ currentPage }
          siteDomainsItems={ domainsList.items }
          siteDomainsTotalItems={ domainsList.meta.totalItems }
          siteDomainsItemsPerPage={ domainsList.meta.itemsPerPage }
          isLoading={ isSiteDomainsFetching }
          handleBack={ handleBack }
          handleChangePage={ handleChangePage }
        />
      ) }
    </FallbackedLayout>
  );
});
